import {mapGetters, mapMutations} from "vuex";

export default {
    computed: {
        ...mapGetters({
            getComplementaryDialogOpen: 'customizer/getComplementaryDialogOpen',
            getComplementaryDialogStep: 'customizer/getComplementaryDialogStep',
            getComplementaryDialogContent: 'customizer/getComplementaryDialogContent',
            getComplementaryDialogConfirm: 'customizer/getComplementaryDialogConfirm',
            getStep: 'customizer/getStep',
            getSteps: 'customizer/getSteps',
            getOptions: 'customizer/getOptions'
        }),
    },
    methods: {
        ...mapMutations({
            setComplementaryDialogOpen: 'customizer/setComplementaryDialogOpen',
            setComplementaryDialogStep: 'customizer/setComplementaryDialogStep',
            setComplementaryDialogContent: 'customizer/setComplementaryDialogContent',
            setComplementaryDialogConfirm: 'customizer/setComplementaryDialogConfirm',
            setStep: 'customizer/setStep'
        }),
        openComplementaryDialog() {
            this.setComplementaryDialogOpen(true)
        },
        acceptComplementaryDialog() {
            // this.setComplementaryDialogOpen(false)
            this.setComplementaryDialogConfirm(true)
        },
        cancelComplementaryDialog() {
            this.setComplementaryDialogOpen(false)
            this.setComplementaryDialogConfirm(false)
        },
        closeComplementaryDialog() {
            this.setComplementaryDialogOpen(false)
            this.setComplementaryDialogConfirm(false)
        }
    }
}
